import { render, staticRenderFns } from "./record-card.vue?vue&type=template&id=a55d146a&scoped=true"
import script from "./record-card.vue?vue&type=script&lang=js"
export * from "./record-card.vue?vue&type=script&lang=js"
import style0 from "./record-card.vue?vue&type=style&index=0&id=a55d146a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_4rliqqz3ui7xo7iaw2ukiguuga/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55d146a",
  null
  
)

export default component.exports